import { render, staticRenderFns } from "./ReleasedPayments.vue?vue&type=template&id=f38123a4&scoped=true&"
import script from "./ReleasedPayments.vue?vue&type=script&lang=js&"
export * from "./ReleasedPayments.vue?vue&type=script&lang=js&"
import style0 from "./ReleasedPayments.vue?vue&type=style&index=0&id=f38123a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38123a4",
  null
  
)

export default component.exports